import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';
import FinanceAdjustDetails from './FinanceAdjustDetails';

class OperationLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    loadData = () => {
        const { record: { investigationId }, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryInvCloseAdjustLogList,
            data: {
                investigationId,
                offset: current,
                limit: pageSize,
            },
            dataType: 'json',
            doneResult: res => {
                const { totalCount, datas } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '操作时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 140,
    }, {
        title: '操作人',
        dataIndex: 'createUserName',
        key: 'createUserName',
        width: 140,
    }, {
        title: '操作内容',
        dataIndex: 'operationContentShow',
        key: 'operationContentShow',
        width: 110,
    }, {
        title: '操作结果',
        dataIndex: 'operationResultShow',
        key: 'operationResultShow',
        width: 110,
    },  {
        title: '审批不通过原因',
        dataIndex: 'noPassReason',
        key: 'noPassReason',
        width: 110,
    },  {
        title: '备注说明',
        dataIndex: 'adjustDesc',
        key: 'adjustDesc',
        width: 110,
    },  {
        title: '附件',
        dataIndex: 'attachments',
        key: 'attachments',
        width: 100,
        render: (text, record) => {
            const { ossFileList } = record;
            console.log(ossFileList);
            return (ossFileList || []).map(el => <a onClick={() => this.downLoadFile(el.id)}>{el.fileName}<br /></a>)
        }
    },  {
        title: '申请详情',
        dataIndex: 'details',
        key: 'details',
        width: 100,
        render: (text, record) => {
            const { operationType, relatedId } = record;
            return operationType === 'FINANCIAL_ADJUST' ? <a onClick={() => this.FinanceAdjustDetailsRef.show(relatedId)}>查看详情</a> : ''
        }
    }]

    downLoadFile = (id) => {
        const url = API_URL.contract.downloadOssFile;
        ExportUtil.export({ id }, null, url);
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const { visible, loading, data, pagination } = this.state;
        return (
            <Modal
                title="操作日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width={1100}
                bodyStyle={{ maxHeight: 700 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <TableC
                        data={data}
                        scrollY={500}
                        rowKey={'id'}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        loading={loading}
                        columns={this.getColumns()}
                    />
                    <FinanceAdjustDetails ref={ el => this.FinanceAdjustDetailsRef = el} />
                </div>
            </Modal>
        );
    }
}

export default OperationLog;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/OperationLog.js